import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import '@/assets/css/reset.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueAwesomeSwiper from 'vue-awesome-swiper'

// import style
import 'swiper/css/swiper.css'

Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
// import {
//   Button, Tabs,TabPane, Form,
//   FormItem,Input,Checkbox
// } from 'element-ui'


// Vue.component(Button.name, Button)
// Vue.component(Tabs.name, Tabs)
// Vue.component(TabPane.name, TabPane)
// Vue.component(Form.name, Form)
// Vue.component(FormItem.name, FormItem)
// Vue.component(Input.name, Input)
// Vue.component(Checkbox.name, Checkbox)

Vue.config.productionTip = false
Vue.use(ElementUI);

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
